<template>
  <div>
    <div id="page-panel">
      <div class="customer-top-nav">
        <div class="title">
          <span>Valorisation des produits d'inventaire</span><br>
        </div>
        <div class="controls no-print">
          <el-button type="primary" size="small" @click="fetchData" :loading="loading">
            Actualiser
          </el-button>
        </div>
      </div>

      <p>
        <span class="fs-14 secondary-text">{{ companyName }}</span><br>
        <span class="fs-14 secondary-text">Total bouteilles: {{ formatQty(grandTotalRemainingQty) }}</span><br>
        <span class="fs-14 secondary-text">Valeur totale: {{ formatCurrency(grandTotalValue) }}</span>
      </p>

      <div v-for="inventory in inventories" :key="inventory.inventoryId" class="inventory-block">
        <div style="display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:8px;">
          <h4 style="margin:0;">
            {{ inventory.inventoryName }} ({{ inventory.inventoryCode }})
            <span class="secondary-text fs-14">
              - {{ formatQty(inventory.totalRemainingQty) }} bouteilles
              - {{ formatCurrency(inventory.totalValue) }}
            </span>
          </h4>
          <el-button type="primary" size="mini" icon="el-icon-download" @click="exportExcel(inventory)">
            Exporter Excel
          </el-button>
        </div>

        <el-table
          :data="inventory.rows"
          style="width: 100%; margin-top: 10px;"
          border
          stripe
          max-height="420"
          empty-text="Aucun produit en inventaire">
          <el-table-column prop="sku" label="SKU" width="120" sortable />
          <el-table-column prop="name" label="Produit" min-width="260" sortable />
          <el-table-column prop="provider_name" label="Producteur" min-width="180" sortable />
          <el-table-column prop="unitPrice" label="Prix unitaire" width="140" align="right" sortable>
            <template slot-scope="scope">
              {{ formatCurrency(scope.row.unitPrice) }}
            </template>
          </el-table-column>
          <el-table-column prop="remainingQty" label="Qté restante" width="130" align="right" sortable>
            <template slot-scope="scope">
              {{ formatQty(scope.row.remainingQty) }}
            </template>
          </el-table-column>
          <el-table-column prop="totalValue" label="Valeur totale" width="150" align="right" sortable :sort-method="sortByTotalValue">
            <template slot-scope="scope">
              <strong>{{ formatCurrency(scope.row.totalValue) }}</strong>
            </template>
          </el-table-column>

        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import InventoryAPI from '@/services/API/inventory';

export default {
  name: 'InventoryProductsValorizationReport',
  props: {
    width: {
      type: Number,
      default: 100,
    },
    companyName: '',
  },
  data() {
    return {
      loading: false,
      inventories: [],
      grandTotalRemainingQty: 0,
      grandTotalValue: 0,
    };
  },
  methods: {
    formatQty(value) {
      return Math.round(Number(value || 0));
    },
    formatCurrency(value) {
      return `${Number(value || 0).toFixed(2)} $`;
    },
    sortByTotalValue(a, b) {
      return Number(a.totalValue || 0) - Number(b.totalValue || 0);
    },
    exportExcel(inventory) {
      const headers = ['SKU', 'Produit', 'Producteur', 'Prix unitaire ($)', 'Qté restante', 'Valeur totale ($)'];
      const rows = _.map(inventory.rows, row => [
        row.sku || '',
        row.name || '',
        row.provider_name || '',
        Number(row.unitPrice || 0).toFixed(2),
        this.formatQty(row.remainingQty),
        Number(row.totalValue || 0).toFixed(2),
      ]);
      const totalRow = [
        '', 'TOTAL', '', '',
        this.formatQty(inventory.totalRemainingQty),
        Number(inventory.totalValue || 0).toFixed(2),
      ];

      const csvContent = [headers, ...rows, totalRow]
        .map(r => r.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(';'))
        .join('\n');

      const bom = '\uFEFF';
      const blob = new Blob([bom + csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `valorisation-${inventory.inventoryCode}-${new Date().toISOString().slice(0, 10)}.csv`;
      link.click();
      URL.revokeObjectURL(url);
    },
    fetchData() {
      this.loading = true;
      return InventoryAPI.fetchInventoryProductsValorization()
        .then((data) => {
          const inventories = _.get(data, 'inventories', []);
          this.inventories = _.map(inventories, inventory => ({
            ...inventory,
            rows: _.orderBy(_.get(inventory, 'rows', []), ['provider_name', 'name'], ['asc', 'asc']),
          }));
          this.grandTotalRemainingQty = Number(_.get(data, 'grandTotalRemainingQty', 0));
          this.grandTotalValue = Number(_.get(data, 'grandTotalValue', 0));
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.inventories = [];
          this.grandTotalRemainingQty = 0;
          this.grandTotalValue = 0;
          this.$message.error('Une erreur systeme est survenue. Veuillez reessayer plus tard');
        });
    },
  },
  created() {
    this.fetchData();
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../assets/scss/_variables';

.title {
  font-size: 1.6em;
  font-weight: bold;
  margin-right: 20px;
  position: relative;
  float: left;
}

.customer-top-nav {
  height: 40px;
}

.controls {
  position: relative;
  float: right;

  button {
    margin-left: 10px;
  }
}

.inventory-block {
  margin-top: 18px;
}
</style>
